import React, { Component } from 'react'
import style from './ecomModule.style'
import Typography from '@material-ui/core/Typography'
import cx from 'classnames'

// COMPONENTS
import Switch from '@material-ui/core/Switch'
import { AccountAlertIcon, ShopModule } from '../../app-icon/Icons'

class EcomModule extends Component {
  state = {
    checked: window.state.module_active,
    errorsEcom: window.state.errorsEcom,
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked })

    const url = '/ecom/active-module'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify({ status: !this.state.checked }),
    })
      .then(status)
      .then(json)
      .then(data => {})
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  render() {
    const {
      classes,
      headerClass,
      wrapperClass,
      title,
      showEcomError,
    } = this.props
    const { checked, errorsEcom } = this.state

    const moduleStatus = checked ? 'Модуль активен' : 'Модуль не активен'

    return (
      <div className={cx(classes.module, wrapperClass)}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          {showEcomError ? (
            <div
              style={{
                position: 'relative',
                width: 44,
                height: 44,
                borderRadius: '100%',
                backgroundColor: 'rgb(255,217,72)',
                overflow: 'hidden',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: 12,
              }}
            >
              <ShopModule width={27} height={24} />
            </div>
          ) : null}

          <header className={cx(classes.header, headerClass)}>
            {showEcomError && errorsEcom && errorsEcom.length > 0 ? (
              <AccountAlertIcon />
            ) : (
              <Switch
                checked={this.state.checked}
                onChange={this.handleChange('checked')}
                value="checked"
                classes={{
                  switchBase: classes.iOSSwitchBase,
                  bar: classes.iOSBar,
                  icon: classes.iOSIcon,
                  iconChecked: classes.iOSIconChecked,
                  checked: classes.iOSChecked,
                  disabled: classes.customDisabled,
                }}
                disabled={errorsEcom && errorsEcom.length > 0 ? true : false}
              />
            )}

            {title ? (
              title
            ) : (
              <Typography variant="body1">
                {errorsEcom.length > 0 ? (
                  <span className={classes.errorTitle}>
                    Проблемы в работе модуля
                  </span>
                ) : (
                  moduleStatus
                )}
              </Typography>
            )}
          </header>
        </div>

        {showEcomError && errorsEcom && errorsEcom.length > 0 ? (
          <main>
            <ul className={classes.ecomErrorsList}>
              {errorsEcom.map(err => (
                <li key={err}>{err}</li>
              ))}
            </ul>
            <a href="/ecom" className={classes.linkTroubleshoot}>
              Устранить проблемы
            </a>
          </main>
        ) : null}
      </div>
    )
  }
}

export default style(EcomModule)
